import React from 'react';
import { connect } from 'react-redux';
import { WebsiteState } from '@gift/website-state/store'
import { scenePlugins } from '@gift/common/helpers/_registry';

const _PreviewSlot = ({ scenePluginId }: Props) => {
    const { PreviewUi } = scenePlugins.require(scenePluginId);
    return <PreviewUi />;
};

type Props = {
    scenePluginId: string
};

const mapStateToProps = (state: WebsiteState) => ({
    scenePluginId: state.scene.pluginId
});

export const PreviewSlot = connect(
    mapStateToProps
)(_PreviewSlot);